<template>
  <vddl-list
    class="jumper panel__body--list"
    :list="list"
    :external-sources="false"
    :disable-if="true"
  >
    <vddl-draggable
      v-for="(item, index) in list"
      :key="item.id"
      :dragstart="onDragStart"
      :type="type"
      :draggable="item"
      :index="index"
      :wrapper="list"
      :moved="onMoved"
      :canceled="onCancel"
      effect-allowed="move"
    >
      <div v-tooltip="options" class="button grab">
        <svg-icon
          :width="'25'"
          :height="'20'"
          icon="app-icons/new-jumper"
          :svg-fill="true"
        />
      </div>
    </vddl-draggable>
  </vddl-list>
</template>

<script>
import Vddl from 'vddl'; // Library For creating the tree structure

import { mapActions } from 'vuex';
import { DRAG_TYPE } from '../../constants.js';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },

  data() {
    return {
      list: [
        {
          id: 0,
        },
      ],
      type: DRAG_TYPE.NEW_JUMPER,
      options: {
        content: 'Drag new jumper',
        placement: 'top',
        distance: 20,
        delay: { show: 800, hide: 0 },
      },
    };
  },

  methods: {
    ...mapActions('application/drag', ['setItems', 'clear']),

    /**
     * Event handler for vddl dragstart event.
     */
    onDragStart(event) {
      const option = this.options;
      option.content = '';
      this.options = { ...this.options, ...option };

      this.setItems({ value: { type: this.type, ids: [] } });
    },

    /**
     * Event handler for vddl moved event.
     */
    onMoved(event) {
      // Clear drag information
      this.clear();

      const option = this.options;
      option.content = 'Drag new jumper';
      this.options = { ...this.options, ...option };
    },

    /**
     * Event handler for vddl canceled event.
     */
    onCancel(event) {
      // Clear drag information
      this.clear();

      const option = this.options;
      option.content = 'Drag new jumper';
      this.options = { ...this.options, ...option };
    },
  },
};
</script>
